import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { RouteActionType } from '../../../context/actions';
import { useRouteContext } from '../../../context/context';

// Hooks act as 'Adapter' layer.
export const useSetSelectedStop = () => {
  const { routeState, routeDispatch } = useRouteContext();
  const { stopId } = useParams();

  useEffect(() => {
    if (stopId !== routeState.selectedStopId) {
      setSelectedStop(stopId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stopId]);

  const setSelectedStop = (stopId: string | undefined) => {
    routeDispatch({
      type: RouteActionType.SET_SELECTED_STOP,
      payload: stopId,
    });
  };

  return {
    selectedStopId: routeState.selectedStopId ?? stopId,
  };
};
